import { useEffect, useState } from 'react';
export function useProgrammaticAdDetection(adRef, mastHeadAdHasLoaded) {
    const [isProgrammatic, setIsProgrammatic] = useState(false);
    useEffect(() => {
        if (adRef.current && mastHeadAdHasLoaded) {
            // Find a candidate element: either one explicitly setting 100% or use firstElementChild as fallback.
            let candidate = adRef.current.querySelector('[width="100%"], [style*="width: 100%"]');
            if (!candidate) {
                candidate = adRef.current.firstElementChild;
                if (candidate) {
                    const fallbackAttrWidth = candidate.getAttribute('width');
                    const fallbackInlineWidth = candidate.style.width;
                    if (!fallbackAttrWidth && !fallbackInlineWidth) {
                        setIsProgrammatic(true);
                        return;
                    }
                }
            }
            if (candidate) {
                const attrWidth = candidate.getAttribute('width');
                const inlineStyleWidth = candidate.style.width;
                // Check if the candidate explicitly sets width to 100% via attribute or inline style.
                if (attrWidth === '100%' || inlineStyleWidth === '100%') {
                    setIsProgrammatic(true);
                    return;
                }
                // Check if the candidate element is occupying the full width of its container
                const computedCandidateWidth = window.getComputedStyle(candidate).width;
                const computedContainerWidth = window.getComputedStyle(adRef.current).width;
                if (computedCandidateWidth &&
                    computedContainerWidth &&
                    parseFloat(computedCandidateWidth) === parseFloat(computedContainerWidth)) {
                    setIsProgrammatic(true);
                    return;
                }
            }
            setIsProgrammatic(false);
        }
    }, [mastHeadAdHasLoaded, adRef]);
    return isProgrammatic;
}
